<ng-container *transloco="let t">
    <div class="logout-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div
                    class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()"
                    [class.component-dark-theme]="themeService.isDark()"
                >
                    <div class="title text-center">
                        <h3>
                            {{t('welcome')}} ALTAIR
                        </h3>
                        <p class="ml-auto mr-auto">
                            {{t('thank-you-for-using')}}
                        </p>
                    </div>
                    <div class="admin text-center">
                        <div class="logo position-relative rounded-circle">
                            <ng-container *ngIf="!themeService.isDark()">
                                <img src="assets/images/icono-intrust-security-ciberseguridad-claro.png" alt="logo">
                            </ng-container>
                            <ng-container *ngIf="themeService.isDark()">
                                <img src="assets/images/icono-intrust-security-ciberseguridad-oscuro.png" alt="logo">
                            </ng-container>
                        </div>
                        <span class="d-block fw-medium">
                            {{t('logged-out')}}
                        </span>
                    </div>
                    <a routerLink="/authentication/sign-in" mat-button class="btn">
                        {{t('sign-in')}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
